module.exports = __webpack_public_path__ + "static/media/affiliate-icon.1d0b4d06.svg";